/** returns naHora transfers list
@return { Array }
*/
export const getNaHoraTransfersList = state => state.naHoraTransfersList
export const getNaHoraTransfersListHasMore = state => state.naHoraTransfersListHasMore

/** returns status list
@return { Array }
*/
export const getStatusList = state => state.statusList

/** returns channels list
@return { Array }
*/
export const getChannelsList = state => state.channelsList

/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}
